<template>
  <div v-perms="['mixcloud']">
    <button :disabled="report_button_disabled" class="btn btn-ss-standout" @click="mixcloudReport(user.email)">
      Send a Report (BETA)
    </button>
    <a target="_blank"
       class="btn btn-ss"
       href="/mixcloud">View Mixcloud Profile</a>
    <br><br>
    <div>Send a Mixcloud status report to <b>{{ user.email }}</b>.</div>
    <div>The report will compare existing items with Mixcloud in both directions and notify you of any problems.</div>
    <br> <hr>
    <div v-perms="['api.mixcloud.set-tags']">
      <br>
      <label for="item_tags">Mixcloud Tags</label>
      <multiselect
        id="mixcloud_tags"
        v-model="ms_tag_values"
        :options="auto_complete_tags"
        :multiple="true"
        :taggable="true"
        placeholder="Search or add new tags..."
        track-by="uuid"
        label="name"
        @tag="addNewTag" />
      <br>
      <div> Any item that is created or updated (if new to Mixcloud) will be automatically pushed if they contain any of the tags specified above.</div>
      <div> Note: tag "mixcloud" is a reserved tag which will always trigger and will be ignored here!</div>
      <br>
      <button class="btn btn-ss-standout" @click="save()">
        Save Tags
      </button>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';

export default {
  mixins: [TaggableModelMixin],
  data: () => ({
    user: window.user,
    report_button_disabled: false,
  }),

  beforeMount() {
    if (this.permissionsCanAccessFeature("mixcloud")) {
      this.fetchTags();
      this.getMixcloudTags();
    }
  },

  methods: {

    async getMixcloudTags() {
      try {
        this.ms_tag_values = (await axios.get('/api/v1/mixcloud/get-tags')).data.data;
      } catch (err) {
        window.handleAxiosError(err);
      }
    },

    async mixcloudReport(email) {
      try {
        (await axios.post('/api/v1/mixcloud/report', {
          email,
        })).data.data;

        toastr.success('Email should arrive shortly.');
      } catch (err) {
        toastr.error('Something went wrong!');
        window.handleAxiosError(err);
      }
    },

    async save() {
      try {
        const data = {
          tags: this.ms_tag_values,
        };
        const response = await axios.post("/api/v1/mixcloud/set-tags", data);
        if (response.data.success) {
          toastr.success(response.data.data.message);
        } else {
          toastr.success("Mixcloud Tags failed to save.");
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },

  },

};
</script>
